import { createFileRoute } from "@tanstack/react-router";
import { Tv6Page } from "@/components/products/Tv6Page";
import { tv6Seo } from "@/lib/page-seo";
import heroLifestyle from "@/assets/products/tv6/hero-lifestyle.jpg";

export const Route = createFileRoute("/products/inext-tv6")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => tv6Seo(loaderData?.href ?? "/products/inext-tv6", heroLifestyle),
  component: Tv6Page,
});
